import numeral from 'numeral';
import { useLivePriceSingleReceiver } from 'global/Datafeed/UseLivePrice/useLivePriceSingleReceiver';
import { Td } from './styled';

const Last = ({ lastPrice, symbol }) => {
  const { livePrice } = useLivePriceSingleReceiver(
    symbol,
    'sector_price',
  );

  const price = livePrice?.lastprice;
  const showLastPrice = typeof price !== 'undefined';
  const lastprice = showLastPrice ? price : lastPrice;
  return (
    <Td align="right" p="0">
      {' '}
      {numeral(lastprice).format('0,0.00')}
    </Td>
  );
};

export default Last;
